import { PortfolioHolding } from '@models';
import {
  ConfigurationCountry,
  ConfigurationLocale,
  FundId,
  PortfolioHoldingDTO,
} from '@types';
import { MapperFactory } from '../mapper-factory';
import { Mapper, MapperParams } from '../type.mapper';

export class HoldingsMapper extends Mapper<PortfolioHolding[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(portfolioHoldingsDTO: PortfolioHoldingDTO[]): PortfolioHolding[] {
    const portfolioHoldings: PortfolioHolding[] = [];

    if (Array.isArray(portfolioHoldingsDTO)) {
      portfolioHoldingsDTO.forEach(
        (portfolioHoldingDTO: PortfolioHoldingDTO) => {
          const portfolioHolding: PortfolioHolding = this.createMapper(
            HoldingMapper
          ).toDomain(portfolioHoldingDTO);

          if (portfolioHolding) {
            portfolioHoldings.push(portfolioHolding);
          }
        }
      );
    }

    return portfolioHoldings;
  }
}

export class HoldingMapper extends Mapper<PortfolioHolding> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(portfolioHoldingDTO: PortfolioHoldingDTO): PortfolioHolding {
    return {
      fundId: portfolioHoldingDTO.fundid as FundId,
      countryCode: portfolioHoldingDTO.cntrycode as ConfigurationCountry,
      languageCode: portfolioHoldingDTO.langcode as ConfigurationLocale,
      asOfDate: portfolioHoldingDTO.asofdate,
      asOfDateStd: portfolioHoldingDTO.asofdatestd,
      updateFrequency: portfolioHoldingDTO.frequency,
      securityTicker: portfolioHoldingDTO.secticker,
      isinSecurityNumber: portfolioHoldingDTO.isinsecnbr,
      securityName: portfolioHoldingDTO.secname,
      industryCode: portfolioHoldingDTO.indstrycode,
      sectorSysNumber: portfolioHoldingDTO.sctrsysno,
      sectorName: portfolioHoldingDTO.sctrname,
      sectorNameStd: portfolioHoldingDTO.sctrnamestd,
      sectorLevelNumber: portfolioHoldingDTO.sctrlvlnbr,
      percentageOfNetAssets: portfolioHoldingDTO.pctofnetassets,
      percentageOfNetAssetsStd: portfolioHoldingDTO.pctofnetassetsstd,
      marketValue: portfolioHoldingDTO.mktvalue,
      notionalMarketValue: portfolioHoldingDTO.notionalmktvalue,
      quantityShrpar: portfolioHoldingDTO.quantityshrpar,
      securityExpirationDate: portfolioHoldingDTO.secexpdate,
      assetClassCategory: portfolioHoldingDTO.assetclasscatg,
      marketCurrency: portfolioHoldingDTO.mktcurr,
      sedolNumber: portfolioHoldingDTO.sedolnbr,
      securityNumber: portfolioHoldingDTO.secnbr,
      cusipNumber: portfolioHoldingDTO.cusipnbr,
      originalCouponRate: portfolioHoldingDTO.origcouponrate,
      contracts: portfolioHoldingDTO.contracts,
      unrealizedGainLossBase: portfolioHoldingDTO.unrealizedgainlossbase,
      finalMaturityDate: portfolioHoldingDTO.finalmaturitydate,
      investmentCategory: portfolioHoldingDTO.investmentcategory,
    };
  }
}
